import emailjs from "@emailjs/browser";
export default async function StoreFormEmail(formData) {
   const response = await emailjs.sendForm(
      "service_q0wjh8u",
      "template_t03f3uf",
      formData,
      {
         publicKey: "bkTpjfjCfk2NRptQH",
      }
   );

   return response
}
